<div class="forbidden-page">
  <div class="card">
    <div class="icon">🔒</div>
    <h1>403 — Acesso negado</h1>
    <p>Você não tem permissão para acessar esta área.</p>
    <div class="actions">
      <button (click)="goDashboard()" class="btn btn-primary">Voltar ao Dashboard</button>
      <button (click)="logoutAndLogin()" class="btn btn-outline">Entrar com outra conta</button>
    </div>
    <small *ngIf="auth.getRoles()?.length">Roles atuais: {{ auth.getRoles() | json }}</small>
  </div>
</div>

